import type { Decimal } from '../decimal.js';

export type BinaryOp = '+' | '-' | '*' | '/' | '^';
export type CompareOp = '<' | '<=' | '>' | '>=' | '==' | '!=';

export type Node =
  | { kind: 'num'; value: Decimal; raw: string; unit?: string; pos: number }
  | { kind: 'ident'; name: string; pos: number }
  | { kind: 'unary'; op: '-'; arg: Node; pos: number }
  | { kind: 'binary'; op: BinaryOp; left: Node; right: Node; pos: number }
  | { kind: 'compare'; op: CompareOp; left: Node; right: Node; pos: number }
  | { kind: 'call'; name: string; args: Node[]; pos: number };

/** Fonctions autorisées dans le DSL (liste fermée : aucune autre fonction n'est appelable). */
export const FUNCTIONS = {
  min: { minArgs: 1, maxArgs: Infinity },
  max: { minArgs: 1, maxArgs: Infinity },
  ceil: { minArgs: 1, maxArgs: 1 },
  floor: { minArgs: 1, maxArgs: 1 },
  round: { minArgs: 1, maxArgs: 2 },
  abs: { minArgs: 1, maxArgs: 1 },
  sqrt: { minArgs: 1, maxArgs: 1 },
  if: { minArgs: 3, maxArgs: 3 },
  sum: { minArgs: 1, maxArgs: 1 },
  count: { minArgs: 1, maxArgs: 1 },
  pi: { minArgs: 0, maxArgs: 0 },
} as const;
export type FunctionName = keyof typeof FUNCTIONS;

export function isFunctionName(name: string): name is FunctionName {
  return Object.prototype.hasOwnProperty.call(FUNCTIONS, name);
}

/** Identifiants référencés par une expression (hors fonctions). */
export function collectIdentifiers(node: Node, out = new Set<string>()): Set<string> {
  switch (node.kind) {
    case 'ident':
      out.add(node.name);
      break;
    case 'unary':
      collectIdentifiers(node.arg, out);
      break;
    case 'binary':
    case 'compare':
      collectIdentifiers(node.left, out);
      collectIdentifiers(node.right, out);
      break;
    case 'call':
      node.args.forEach((a) => collectIdentifiers(a, out));
      break;
    case 'num':
      break;
  }
  return out;
}
